module.exports = __webpack_public_path__ + "img/objects-align-center-horizontal.759504e5.svg";